import type { VistoryRoom } from '@/features/vistories/types/vistory.types';

export interface RoomPhotoProgress {
  photographed: number;
  total: number;
}

/**
 * Counts how many rooms have at least one photo attached.
 */
export function countPhotographedRooms(rooms: VistoryRoom[]): RoomPhotoProgress {
  const total = rooms.length;
  const photographed = rooms.filter(r => (r.photos?.length ?? 0) > 0).length;
  return { photographed, total };
}
